import {Competitor} from "../competitor";
import {Race} from "../race";

export class LeagueCompetitor {
    id?: number;
    leagueId?: number;
    firstName?: string;
    lastName?: string;
    teamName?: string;
    isTeam?: boolean;
    teamMembers?: LeagueCompetitor[];
    team?: string;
    country?: number;
    sex?: number;
    email?: string;
    created?: Date;
    modified?: Date;
    birthday?: Date;
    matchStatus?: MatchStatus;
    rounds?: Race[];
    categoryItemId?: number;
    categoryItemLabel?: string;
    teamComposition?: TeamComposition;
}


export enum MatchStatus {
    FULL_MATCH = 1,
    MERGED = 2,
    DUPLICATE = 3,
    MERGED_DUPLICATE = 4
}

export class TeamComposition {
    maleCount?: number;
    femaleCount?: number;
}
